module.exports = __webpack_public_path__ + "img/eh.50d03c6f.svg";